import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { DialogService } from 'primeng/dynamicdialog';
import {
  PersonDetail,
  SubscriberControllerService,
  SubscriberInfo
} from 'src/app/admin-api';
import { Address } from 'src/app/admin-api/model/address';
import {
  AddressSaveResult,
  EDIT_PERSON_ADDRESS_ROLES
} from 'src/app/services/person-address.util';
import { AddressEditModalComponent } from '../address-edit-modal/address-edit-modal.component';

@Component({
  selector: 'app-address-card',
  templateUrl: './address-card.component.html',
  styleUrl: './address-card.component.scss'
})
export class AddressCardComponent {
  @Input()
  address: Address | undefined;

  @Input()
  subscribers: Array<SubscriberInfo> = [];

  @Input()
  person: PersonDetail | undefined;

  @Output()
  addressSaved = new EventEmitter<AddressSaveResult>();

  readonly editAddressRoles = [...EDIT_PERSON_ADDRESS_ROLES];

  public subscriberControllerService = inject(SubscriberControllerService);
  private dialog = inject(DialogService);
  private permissions = inject(NgxPermissionsService);

  async edit(): Promise<void> {
    const allowed = await this.permissions.hasPermission([
      ...this.editAddressRoles
    ]);
    if (!allowed || !this.address?.addressId) return;

    this.dialog
      .open(AddressEditModalComponent, {
        header: 'Editar endereço',
        width: '640px',
        modal: true,
        closable: true,
        closeOnEscape: true,
        data: {
          address: this.address,
          personId: this.person?.personId ?? this.address.personId
        }
      })
      .onClose.subscribe((result: AddressSaveResult | undefined) => {
        if (result?.address) this.addressSaved.emit(result);
      });
  }

  isAddressVinculatedInSubscriber(): boolean {
    return this.subscribers?.some(
      (sub) => sub.addressIdActiveOnSubscriber === this.address.addressId
    );
  }

  isAddressVinculatedInPerson(): boolean {
    return this.person?.addressId === this.address?.addressId;
  }
}
